import { elementViewed } from 'js/store/helpers/tagular-events'

const nav = document.body.querySelector('header.br-header')

const authBtn = nav.querySelector('[data-nav-check-authentication="auth-btn"]')

const signinBtn = nav.querySelector(
  '[data-nav-check-authentication="auth-app-btns"]'
)

const signinBtnMobile = nav.querySelector(
  '[data-nav-check-authentication="auth-app-signin-mobile"]'
)

const authSidebar = nav.querySelector(
  '[data-nav-check-authentication="br-auth__nav"]'
)

const accountCaptureBanners = nav.querySelectorAll(
  '[data-nav-check-authentication="br-auth__nav-banner"]'
)

function userIsAuthenticated() {
  const regex = new RegExp('BAEAU' + '=([^;]+)')
  const value = regex.exec(window.document.cookie)
  return value != null ? decodeURIComponent(value[1]) : null
}

function initAuthNav() {
  if (userIsAuthenticated()) {
    setAuthenticatedDisplayProperties()
  } else {
    setDefaultDisplayProperties()
  }
}

function setAuthenticatedDisplayProperties() {
  handleSidebar()
  authBtn.style.display = 'block'
  signinBtn.style.display = 'none'
  signinBtnMobile.textContent = 'My Dashboard'

  // set all account capture banners to display none
  for (let i = 0; i < accountCaptureBanners.length; i++) {
    accountCaptureBanners[i].setAttribute('style', 'display: none !important')
  }
}

function setDefaultDisplayProperties() {
  signinBtnMobile.textContent = 'Sign in'
  authBtn.style.display = 'none'
  signinBtn.style.display = 'flex'

  // set all account capture banners to display block
  for (let i = 0; i < accountCaptureBanners.length; i++) {
    accountCaptureBanners[i].setAttribute('style', 'display: block !important')
  }

  // If the flag is enabled, set this value to be display none
  if (authSidebar) {
    authSidebar.style.display = 'none'
  }
}

function handleSidebar() {
  // Element viewed tracking for the authenticated sidebar navigation.
  // Because we are showing and hiding the sidebar with CSS, we need to fire the element viewed event here for reliability.
  if (
    authSidebar &&
    authSidebar.style.display === 'none' &&
    window.innerWidth > 999
  ) {
    // If the flag is enabled, set this value to be display block
    authSidebar.style.display = 'block'

    // send tagular event
    elementViewed({
      elementType: 'Sidebar',
      htmlId: 'Auth_Persistent_Nav',
      location: document.title,
      position: 'left rail',
      text: 'Auth_Persistent_Nav'
    })
  }
}

initAuthNav()

// Export for use by Auth exp
window.initAuthNav = initAuthNav
